import { TicketIcon } from './TicketIcon';

/**
 * author: Google
 * id 18F55984-07FD-4630-BB11-8285F83AA838
 * name ticket
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ticket.svg
 * tags
 */
export const LocalActivityIcon = TicketIcon;
export default LocalActivityIcon